{{vkc.name}}
<app-simple-pie
  [percent]="this.percentage * 100"
  [color]="'#ff00ff'"
  [diameter]="diameter"
></app-simple-pie>